export default "__VITE_ASSET__DwqP3i6v__"